import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getOrderAttributeFn, OrderAttributeResultModel } from "@tKgpco/Services/OrderDetailsAttributeService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = { orderNumber: string } & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, OrderAttributeResultModel[]>;

export const BeginGetOrderDetailAttribure: HandlerType = props => {
    props.dispatch({ type: "Custom/OrderDetailAttribute/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getOrderAttributeFn(props.parameter.orderNumber);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteGetOrderDetailAttribure: HandlerType = props => {
    props.dispatch({
        type: "Custom/OrderDetailAttribute/CompleteLoad",
        orderAttributeCollection: props.apiResult,
    });
};

export const chain = [BeginGetOrderDetailAttribure, RequestDataFromApi, CompleteGetOrderDetailAttribure];

const getOrderDetailAttributeHandler = createHandlerChainRunner(chain, "getOrderDetailAttributeHandler");
export default getOrderDetailAttributeHandler;
